export default {
  getTaskStatistics: state => state.task_statistics,
  getUsersList: state => state.users,
  getPrioritiesList: state => state.priorities_list,
  getCalendarTaskList: state => state.calendar_task_list,
  getComments: state => state.comments,
  getAttachmentFiles: state => state.attachments,

  getStepsList(state) {
    return state.steps
  },

  getOneTask(state) {
    return state.task
  },

  getTaskStatisticList(state) {
    return state.task_statistic_list
  },
  getTaskManagerList(state) {
    return state.task_manager_list
  },

}
